import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../../components/button/button";
import {
  editDestination,
  popular_destination_post,
  popular_destination_single_data,
} from "../../../services/authServices";

const PopularDestinationForm = () => {
  const { id } = useParams();
  const [popularDest, setPopularDest] = useState({
    title: "",
    image: "",
    order_id: "",
  });
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (id !== undefined && id !== null) {
      // const params = {
      //   title: popularDest.title,
      //   order_id: popularDest.order_id,
      //   image: popularDest.image
      // };
      // try {
      //   const res = await editDestination(id, params);
      //   setPopularDest(res.data.Data);
      //   navigate(`/popularDestination`);
      // } catch (e) {
      //   console.error(e);
      try {
        const formData = new FormData();
        formData.append("title", popularDest.title);
        formData.append("order_id", popularDest.order_id);
        formData.append("image", popularDest.image);
        const res = await editDestination(id, formData);
        setPopularDest(res.data.Data);
        navigate(`/popularDestination`);
      } catch (e) {
        console.error(e);
      }
    
    } else {
      try {
        const formData = new FormData();
        formData.append("title", popularDest.title);
        formData.append("order_id", popularDest.order_id);
        formData.append("image", popularDest.image);
        const res = await popular_destination_post(formData);
        setPopularDest(res.data.Data);
        navigate(`/popularDestination`);
      } catch (e) {
        console.error(e);
      }
    }
  };

  const popularDataAPI = async () => {
    if (id !== undefined) {
      try {
        const res = await popular_destination_single_data(id);
        setPopularDest(res.data.Data);
      } catch (e) {
        console.error(e);
      }
    }
  };
  const goBack = () => {
    navigate(-1);
  };

  // Form data format
  const onChangePicture = (e) => {
    setPopularDest({
      ...popularDest,
      image: e.target.files[0],
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPopularDest({ ...popularDest, [name]: value });
  };
  useEffect(() => {
    popularDataAPI();
  }, [id]);
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Order Id</Form.Label>
          <Form.Control
            type="text"
            placeholder="Order Id"
            autoComplete="off"
            name="order_id"
            value={popularDest.order_id}
            onChange={(e) => handleChange(e)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Popular Destination Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Destination Name"
            autoComplete="off"
            name="title"
            value={popularDest.title}
            onChange={(e) => handleChange(e)}
          />
        </Form.Group>

        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Destination Image</Form.Label>
          <Form.Control
            type="file"
            name="image"
            onChange={(e) => onChangePicture(e)}
          />
          <Form.Text className="text-muted">
            Upload an Image of the destination.
          </Form.Text>
        </Form.Group>

        <div className="d-flex mx-2">
          <CustomButton buttonText={"Go Back"} onClick={goBack} />
          <CustomButton buttonText={"Submit"} type={"submit"} />
        </div>
      </Form>
    </>
  );
};

export default PopularDestinationForm;
